module.exports = __webpack_public_path__ + "static/screen-day-4-cf1ca26ac3ace6588c6be5180622fb72.png";